import { Container } from "@material-ui/core";
import useLanguageStore from "@stores/languageStore";
import { useTranslation } from "react-i18next";
import SEOHead from "../../components/SEOHead";
import SectionHeader from "../../components/SectionHeader";

const NationalInsurancePage = () => {
	const { t } = useTranslation();
	const { language } = useLanguageStore();
	const isRtl = language === "he";

	return (
		<div
			className={`min-h-[calc(100vh-64px)] py-20 sm:py-32 max-w-[100vw] overflow-x-hidden ${
				isRtl ? "rtl" : "ltr"
			}`}
		>
			<SEOHead
				titleKey="nationalInsurance.meta.title"
				descriptionKey="nationalInsurance.meta.description"
			/>
			<Container maxWidth="lg" className="px-4 sm:px-8">
				<SectionHeader
					title={t("nationalInsurance.title")}
					className="mb-12"
					titleWeight="800"
				/>

				<div
					className={`leading-relaxed text-base mb-8 max-w-4xl mx-auto ${isRtl ? "text-right" : "text-left"}`}
				>
					<p className="mb-8 text-lg">{t("nationalInsurance.content.intro")}</p>

					<section className="mb-8">
						<h2 className="text-2xl font-bold mb-4 text-[#063447]">
							{t("nationalInsurance.content.section1.title")}
						</h2>
						<div className="bg-stone-50 p-6 rounded-lg border-r-4 border-[#063447]">
							<p className="font-bold mb-2">
								{t("nationalInsurance.content.section1.important")}
							</p>
							<p className="mb-4">{t("nationalInsurance.content.section1.text")}</p>
							<p className="text-sm text-gray-600 italic">
								{t("nationalInsurance.content.section1.note")}
							</p>
						</div>
					</section>

					<section className="mb-8">
						<h2 className="text-2xl font-bold mb-4 text-[#063447]">
							{t("nationalInsurance.content.section2.title")}
						</h2>
						<p className="mb-4">{t("nationalInsurance.content.section2.text")}</p>
						<ul className="list-disc pr-6 mb-4 space-y-2">
							<li>{t("nationalInsurance.content.section2.item1")}</li>
							<li>{t("nationalInsurance.content.section2.item2")}</li>
							<li>{t("nationalInsurance.content.section2.item3")}</li>
						</ul>
						<p className="font-bold text-[#063447]">
							{t("nationalInsurance.content.section2.important")}
						</p>
					</section>

					<section className="mb-8">
						<h2 className="text-2xl font-bold mb-4 text-[#063447]">
							{t("nationalInsurance.content.section3.title")}
						</h2>
						<p>{t("nationalInsurance.content.section3.text")}</p>
					</section>

					<section className="mb-8">
						<h2 className="text-2xl font-bold mb-4 text-[#063447]">
							{t("nationalInsurance.content.section4.title")}
						</h2>
						<p className="mb-4">{t("nationalInsurance.content.section4.text")}</p>
						<ul className="list-disc pr-6 mb-4 space-y-2">
							<li>{t("nationalInsurance.content.section4.item1")}</li>
							<li>{t("nationalInsurance.content.section4.item2")}</li>
						</ul>
						<div className="bg-[#063447] text-white p-4 rounded-lg shadow-md">
							<p className="font-bold">
								💡 {t("nationalInsurance.content.section4.tip")}
							</p>
						</div>
					</section>

					<section className="mb-12">
						<h2 className="text-2xl font-bold mb-4 text-[#063447]">
							{t("nationalInsurance.content.section5.title")}
						</h2>
						<p>{t("nationalInsurance.content.section5.text")}</p>
					</section>

					<div className="bg-gray-100 p-8 rounded-xl text-center">
						<h3 className="text-xl font-bold mb-4">
							{t("nationalInsurance.content.summary.title")}
						</h3>
						<p className="mb-6">{t("nationalInsurance.content.summary.text")}</p>
						<p className="text-sm text-gray-500">
							{t("nationalInsurance.content.disclaimer")}
						</p>
					</div>
				</div>
			</Container>
		</div>
	);
};

export default NationalInsurancePage;




